import { useLayoutEffect } from 'react';

// Reserve the fixed header's actual height, including safe areas, guest actions,
// wrapped drafts and status text. Scrolling never replaces or moves the input.
export const useHomeAskClearance = ({ pageRef, dockRef, editing }) => {
    useLayoutEffect(() => {
        if (editing) return undefined;
        const page = pageRef.current;
        const dock = dockRef.current;
        if (!page || !dock) return undefined;
        const measure = () => {
            const { height } = dock.getBoundingClientRect();
            // Retained Ask backgrounds have no geometry; keep their clearance.
            if (!height || page.closest('[hidden]')) return;
            page.style.setProperty('--home-pinned-height', `${height}px`);
        };
        const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
        observer?.observe(dock);
        window.addEventListener('resize', measure);
        measure();
        return () => {
            observer?.disconnect();
            window.removeEventListener('resize', measure);
        };
    }, [pageRef, dockRef, editing]);
};
